var map = {
	"./ADA.svg": 816,
	"./BCH.svg": 817,
	"./BNB.svg": 818,
	"./BTC.svg": 819,
	"./CHZ.svg": 820,
	"./DASH.svg": 821,
	"./DOGE.svg": 822,
	"./DOT.svg": 823,
	"./ETC.svg": 824,
	"./ETH.svg": 825,
	"./EUR.svg": 826,
	"./GBP.svg": 827,
	"./LINK.svg": 828,
	"./LTC.svg": 829,
	"./MATIC.svg": 830,
	"./MKR.svg": 831,
	"./SHIB.svg": 832,
	"./SOL.svg": 833,
	"./TRX.svg": 834,
	"./UNI.svg": 835,
	"./USD.svg": 836,
	"./USDT.svg": 837,
	"./XLM.svg": 838,
	"./XMR.svg": 839,
	"./XRP.svg": 840,
	"./documents.svg": 841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 815;